import { apiFetch } from './client.js';

/**
 * The parent takes the family a coach started, from the invitation's link
 * (stage C). Sends the link's hash, never the link (as the setup page does);
 * answers with the athlete to finish next.
 *
 * Refusals come back as ApiError: link_dead, other_email (with the address the
 * link is for, in `email`), has_account.
 */
export function claimFamilyInvitation(
  getToken: () => Promise<string | null>,
  hash: string,
): Promise<{ athlete_client_id: string | null }> {
  return apiFetch(`/api/family-invitations/${hash}/claims`, getToken, { method: 'POST' });
}
